// Open any link pointing at a Google Form in an embedded modal instead of
// navigating away. The iframe src is only set on first open (lazy-loaded),
// and falls back to a normal link if the modal markup isn't on the page.
export default function quoteModal() {
    const modal = document.getElementById('counsel-quote-modal');
    if (!modal) {
        return;
    }

    const iframe = modal.querySelector('.counsel-modal-iframe');
    const triggers = document.querySelectorAll('a[href*="docs.google.com/forms"]');

    if (!triggers.length) {
        return;
    }

    function openModal(formUrl) {
        if (!iframe.src) {
            const separator = formUrl.indexOf('?') === -1 ? '?' : '&';
            iframe.src = formUrl + separator + 'embedded=true';
        }
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('counsel-modal-open');
    }

    function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('counsel-modal-open');
    }

    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', function (event) {
            event.preventDefault();
            openModal(trigger.href);
        });
    });

    modal.querySelectorAll('[data-modal-close]').forEach(function (el) {
        el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
            closeModal();
        }
    });
}
